// Le numéro de compte (code) est l'identifiant — pas d'_id
export class AccountModel {
  code: string;
  label: string;
}

export class AccountChartModel {
  _id: string;
  label: string;
  application: string;
  accounts?: AccountModel[];
  updatedAt?: Date;
}

// Snapshot embarqué dans l'établissement — miroir du AccountChartRelation backend
export type AccountChartRelationModel = Pick<AccountChartModel, '_id' | 'label' | 'application'>;

// Compte tel que stocké sur les lignes (panier, facture) et renvoyé par
// GET establishment/:_id/accounting-accounts/list — miroir de toAccountLine backend
export interface AccountLineModel {
  accountNumber: string;
  label: string;
  display?: string;
}

/** Copie du compte avec son libellé d'affichage « numéro - libellé ». */
export const withAccountDisplay = (account: AccountLineModel): AccountLineModel => ({
  ...account,
  display: `${account.accountNumber} - ${account.label}`,
});

/**
 * Élément de `accounts` correspondant à `current`, comparé par numéro de compte.
 * Un compte affecté avant le passage au plan de l'établissement peut ne pas figurer dans la liste :
 * il y est alors ajouté pour rester affiché et sélectionné.
 */
export function findOrAppendAccount(accounts: AccountLineModel[], current: AccountLineModel): AccountLineModel | null {
  if (!current?.accountNumber) {
    return null;
  }
  // String() : les anciennes lignes du plan du tenant stockaient parfois le numéro en nombre
  const found = accounts.find(account => String(account.accountNumber) === String(current.accountNumber));
  if (found) {
    return found;
  }
  const appended = withAccountDisplay(current);
  accounts.push(appended);
  return appended;
}
